module.exports = __webpack_public_path__ + "img/horizontal_7_7_8011.2a967079.png";